export const GMB_SEARCH = {
  CENTER: "center",
  GOOGLE: "google"
};

export const FACILITY_CREATE_ACTION = {
  EXISTS_IN_ACCOUNT: "existsInAccount",
  WITH_OWNER: "withOwner",
  WITHOUT_OWNER: "withoutOwner"
};
